import React from 'react';
import {Cell} from '../Cell';
import {SortableColumnState} from '../../types';

type DataTableProps = {
    id?: string;
    bordered?: boolean;
    condensed?: boolean;
    striped?: boolean;
    headings: any[];
    rows: any[];
    cellRenderers?: any;
    headerCellRenderers?: any;
    classNames?: string;
    onRowClick?: (row: any) => void;
    sortable?: boolean;
    setSort?: (state: SortableColumnState) => void;
    sortState?: SortableColumnState;
    responsive?: boolean;
};

// Simple DataTable, inspired by: https://engineering.shopify.com/blogs/engineering/building-data-table-component-react
export const DataTable: React.FunctionComponent<DataTableProps> = ({
                                                                       id,
                                                                       bordered = false,
                                                                       condensed = false,
                                                                       striped = false,
                                                                       headings,
                                                                       rows,
                                                                       cellRenderers,
                                                                       headerCellRenderers,
                                                                       classNames,
                                                                       sortable = false,
                                                                       setSort,
                                                                       sortState,
                                                                       children,
                                                                       onRowClick,
                                                                       responsive = false,
                                                                   }) => {
    const renderHeadingRow = (cell: any, cellIndex: number) => {
        const cellPropClass = cell.prop
            .toLowerCase()
            .replace(/[^a-z0-9]/g, '_')
            .replace(/_{2,}/g, '_')
            .replace(/_$/, '');

        return (
            <Cell
                key={`heading-${cellIndex}`}
                content={cell.label}
                prop={cell.prop}
                header={true}
                sortable={sortable}
                setSort={setSort}
                sortState={sortState}
                classNames={`cell-${cellIndex} cell-${cellPropClass}`}
            />
        )
    };

    const renderRow = (row: any, rowIndex: number) => {
        return (
            <tr key={`row-${rowIndex}`}
                onClick={() => {
                    onRowClick && onRowClick(row)
                }}
            >
                {headings.map((heading, cellIndex) => {
                    const cellPropClass = heading.prop
                        .toLowerCase()
                        .replace(/[^a-z0-9]/g, '_')
                        .replace(/_{2,}/g, '_')
                        .replace(/_$/, '');

                    const cellFieldTypeClass = heading.hasOwnProperty('fieldType') ? 'cell-' + heading.fieldType : '';

                    return (
                        cellRenderers && cellRenderers.hasOwnProperty(heading.prop) ?
                            cellRenderers[heading.prop](`${rowIndex}-${cellIndex}`, row[heading.prop], row)
                            :
                            <Cell
                                key={`${rowIndex}-${cellIndex}`}
                                content={row[heading.prop]}
                                classNames={`cell-${cellIndex} cell-${rowIndex}-${cellIndex} cell-${cellPropClass} ${cellFieldTypeClass}`}
                            />
                    )
                })}
            </tr>
        )
    };
console.log('Headings', headings);
    const theadMarkup = (
        <tr key="heading">
            {headings.map(renderHeadingRow)}
        </tr>
    );

    const tbodyMarkup = rows.map(renderRow);

    const tableClassNames = [
        'table',
        bordered && 'table-bordered',
        condensed && 'table-sm',
        striped && 'table-striped',
        classNames && classNames,
    ]
        .filter(Boolean)
        .join(' ');

    const tableContainerClassNames = [
        responsive && 'table-responsive'
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <div className={tableContainerClassNames}>
            <table id={id} className={tableClassNames}>
                <thead>{theadMarkup}</thead>
                <tbody>{tbodyMarkup}</tbody>
            </table>
            {children}
        </div>
    );
};
